import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { SetEditorFlow } from '@/contexts/SetEditorContext';
import { SentenceSetContextProvider } from '@/contexts/SentenceSetContext/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';
import { StackScreenProps } from '@react-navigation/stack';
import { useLayoutEffect } from 'react';

const TITLE: Partial<Record<SetEditorFlow, string>> = {
  createSet: 'Sätzeset erstellen',
  createTemplate: 'Vorlage erstellen',
  templateFromSet: 'Vorlage erstellen',
  editTemplate: 'Vorlage bearbeiten',
  duplicateTemplate: 'Vorlage duplizieren',
};

export default function SentenceSet(
  props: StackScreenProps<TherapistStackParamList, 'SentenceSet'>,
) {
  const { flow } = props.route.params;

  useLayoutEffect(() => {
    const title = TITLE[flow];
    if (!title) {
      return;
    }
    props.navigation.setOptions({
      title,
      headerTitleAllowFontScaling: false,
    });
  }, [props.navigation, flow]);

  return (
    <SentenceSetContextProvider
      setId={props.route?.params?.setId}
      patientId={props.route?.params?.selectedID}
      apiName={props.route?.params?.apiName}
      fromTemplate={props.route?.params?.fromTemplate}
    >
      <SetsSelectedWrapper props={props} />
    </SentenceSetContextProvider>
  );
}
